<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.8333 8.33325C13.25 8.58325 14.5 9.08325 15.6667 9.99992L18 7.58325V13.4166H12.1667L14.4167 11.1666C11.3333 8.91659 7.08333 9.66659 4.91667 12.7499C4.75 12.9999 4.58333 13.1666 4.5 13.4166L3 12.6666C4.75 9.49992 8.25 7.74992 11.8333 8.33325Z"/>
</svg>
